<div class="post-holder" *ngIf="dataIsReady">
  <div
    [ngClass]="
      post.featuredImagePath
        ? 'post-creator-holder'
        : 'post-creator-holder-without-img'
    "
    class=""
  >
    <div
      class="post-logo-holder"
      [ngStyle]="{ right: post.featuredImagePath ? '16px' : '0' }"
      (click)="profile(post.user.userName)"
    >
      <img
        *ngIf="post.user.avatarPath !== ''"
        src="{{ post.user.avatarPath }}"
        onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
      />
      <img *ngIf="post.user.avatarPath === ''" src="assets/blog/avatar.svg" />
    </div>
    <div
      class="post-creator-title"
      [ngStyle]="{ right: post.featuredImagePath ? '62px' : '46px' }"
      (click)="profile(post.user.userName)"
    >
      {{ post.user.userName }}
    </div>
    <div
      class="post-date-label"
      [ngStyle]="{ right: post.featuredImagePath ? '62px' : '46px' }"
    >
      {{ dateLabelString }}
    </div>
    <div class="close" (click)="closeDetail()">بستن</div>
  </div>
  <div
    class="post-mid-holder"
    id="scrollMe"
    [ngStyle]="{
      height: post.featuredImagePath
        ? isReplyActivated
          ? 'calc( 100% - 170px )'
          : 'calc( 100% - 129px )'
        : isReplyActivated
        ? 'calc( 100% - 179px )'
        : 'calc( 100% - 138px )'
    }"
  >
    <div class="post-img-holder" *ngIf="post.featuredImagePath">
      <img src="{{ post.featuredImagePath }}" />
    </div>
    <div class="post-bottom-div">
      <div class="post-like-div" (click)="likeSelected()">
        <div class="post-icon-holder">
          <img src="assets/blog/like.svg" *ngIf="!post.isLiked" />
          <img src="assets/blog/liked.svg" *ngIf="post.isLiked" />
        </div>
        <div class="post-number">
          <p style="margin: 0; color: rgb(110, 110, 110); font-size: 13px">
            {{ post.likes }} نفر پسندیده‌اند
          </p>
        </div>
      </div>
      <div class="post-comment-div">
        <div class="post-icon-holder">
          <img src="assets/blog/comment.svg" />
        </div>
        <div class="post-number">
          <p style="margin: 0; color: rgb(110, 110, 110); font-size: 13px">
            {{ post.comments }} نظر داده شده
          </p>
        </div>
      </div>
      <div class="more-options" (click)="showMoreOptions()">
        <div class="more-dot-holder">
          <div class="dot-shape" style="right: 8px"></div>
          <div class="dot-shape" style="right: 14px"></div>
          <div class="dot-shape" style="right: 20px"></div>
        </div>
      </div>
    </div>
    <div
      class="post-text"
      *ngIf="post.text"
      [ngStyle]="{
        'text-align': isPersian ? 'right' : 'left',
        direction: hasMention ? 'ltr' : 'rtl'
      }"
      attr.id="postText{{ id }}"
    >
      .
    </div>
    <div class="line-divider" style="top: 48px"></div>

    <div class="comments-holder" id="comment">
      <div
        class="comment-holder"
        *ngFor="let comment of comments; let i = index"
      >
        <div
          class="comment-body"
          attr.id="id{{ id }}commentholder{{ comment.id }}"
        >
          <div
            class="comment-avatar-holder"
            (click)="profile(comment.user.userName)"
          >
            <img
              class="comment-avatar"
              *ngIf="comment.user.avatarPath !== ''"
              src="{{ comment.user.avatarPath }}"
              onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
            />
            <img
              class="comment-avatar"
              *ngIf="comment.user.avatarPath === ''"
              src="assets/blog/avatar.svg"
            />
          </div>
          <div
            class="comment-text-holder"
            (swiperight)="swipeComment(comment, $event.type, id)"
            (swipeleft)="swipeComment(comment, $event.type, id)"
          >
            <span
              class="comment-text"
              attr.id="id{{ id }}comment{{ comment.id }}"
              (click)="profile(comment.user.userName)"
              >.</span
            >
          </div>
          <div class="comment-date-label">
            {{ dateHelper.getPostTimeLabel(comment.createdAt) }}
          </div>
          <div class="comment-button" (click)="activateReply(comment)">
            پاسخ
          </div>
          <!-- <div class="comment-button" (click)="removeCommentPopup(comment.id)" *ngIf="comment.user.id === blogUser.id">حذف</div> -->
          <div class="more-actions">
            <div
              class="more-action-report"
              *ngIf="comment.user.id !== blogUser.id"
              (click)="showCommentReportBottomsheet(comment.id)"
            >
              <img class="more-action-img" src="assets/blog/report.svg" />
            </div>
            <div
              class="more-action-report"
              *ngIf="comment.user.id === blogUser.id"
              (click)="removeCommentPopup(comment.id)"
            >
              <img class="more-action-img" src="assets/blog/delete.svg" />
            </div>
            <div class="more-action-separator"></div>
            <div class="more-action-reply" (click)="activateReply(comment)">
              <img class="more-action-img" src="assets/blog/reply.svg" />
            </div>
          </div>
        </div>
        <div
          *ngIf="comment.replies.length > 0"
          class="comment-has-reply-holder"
          (click)="changeReplyPage(comment)"
        >
          <div class="comment-has-reply-line"></div>
          <div
            *ngIf="comment.replies.length <= comment.repliesPage * 3"
            class="comment-has-reply"
          >
            عدم نمایش پاسخ‌ها
          </div>
          <div
            *ngIf="comment.replies.length > comment.repliesPage * 3"
            class="comment-has-reply"
          >
            نمایش {{ comment.replies.length - 3 * comment.repliesPage }} پاسخ
          </div>
        </div>
        <div *ngFor="let reply of comment.replies; let i = index">
          <div
            *ngIf="i >= comment.replies.length - comment.repliesPage * 3"
            class="comment-reply-holder"
            attr.id="id{{ id }}replyholder{{ reply.id }}"
          >
            <div
              class="comment-reply-img-holder"
              (click)="profile(reply.user.userName)"
            >
              <img
                *ngIf="reply.user.avatarPath !== ''"
                src="{{ reply.user.avatarPath }}"
                onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
              />
              <img
                *ngIf="reply.user.avatarPath === ''"
                src="assets/blog/avatar.svg"
              />
            </div>
            <div
              class="comment-reply-text"
              attr.id="id{{ id }}reply{{ reply.id }}"
              (swiperight)="swipeReply(reply, $event.type, id)"
              (swipeleft)="swipeReply(reply, $event.type, id)"
              (click)="profile(reply.user.userName)"
            >
              .
            </div>
            <div class="comment-reply-date">
              {{ dateHelper.getPostTimeLabel(reply.createdAt) }}
            </div>
            <div
              class="comment-reply-title"
              (click)="activateReplyReply(comment, reply)"
            >
              پاسخ
            </div>
            <!-- <div class="comment-reply-title" *ngIf="reply.user.id === blogUser.id">حذف</div> -->
            <div class="more-actions-reply">
              <div
                class="more-action-report"
                *ngIf="reply.user.id !== blogUser.id"
                (click)="showReplyReportBottomsheet(reply.id)"
              >
                <img class="more-action-img" src="assets/blog/report.svg" />
              </div>
              <div
                class="more-action-report"
                *ngIf="reply.user.id === blogUser.id"
                (click)="removeReplyPopup(comment.id, reply.id)"
              >
                <img class="more-action-img" src="assets/blog/delete.svg" />
              </div>
              <div class="more-action-separator"></div>
              <div
                class="more-action-reply"
                (click)="activateReplyReply(comment, reply)"
              >
                <img class="more-action-img" src="assets/blog/reply.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="show-more" *ngIf="hasMoreComments">
      <div class="show-more-button" (click)="showMoreComments()">
        نظرات بیشتر
      </div>
    </div>
  </div>
  <div *ngIf="showTagView" class="search-tag-view">
    <p *ngIf="searchedTags.length === 0" class="center-text">
      تگ مورد نظر یافت نشد
    </p>
    <div class="tableView" *ngIf="searchedTags.length !== 0">
      <table class="table table-striped">
        <tbody>
          <tr
            *ngFor="let tag of searchedTags; let i = index"
            (click)="replaceTagInSearch(tag)"
          >
            <td>
              <div class="table-row-img">
                <p>#</p>
              </div>
              <div class="table-row-title">
                {{ tag.title }}
              </div>
              <div class="table-row-post-count">{{ tag.postCount }} پست</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="showUserView" class="search-tag-view">
    <p *ngIf="searchedUsers.length === 0" class="center-text">
      کاربر مورد نظر یافت نشد
    </p>
    <div class="tableView" *ngIf="searchedUsers.length !== 0">
      <table class="table table-striped">
        <tbody>
          <tr
            *ngFor="let user of searchedUsers; let i = index"
            (click)="replaceUsernameInSearch(user.userName)"
          >
            <td>
              <img
                class="post-detail-user-avatar"
                *ngIf="user.avatarPath !== ''"
                src="{{ user.avatarPath }}"
                onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
              />
              <img
                class="post-detail-user-avatar"
                *ngIf="user.avatarPath === ''"
                src="assets/blog/avatar.svg"
              />
              <div class="post-detail-user-username">{{ user.userName }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="bot-container">
    <div class="reply-activated" attr.id="id{{ id }}replyActivated">
      <div class="reply-activated-text">پاسخ به {{ replyUsername }}</div>
      <div class="reply-cancel" (click)="deactivateReply()">
        <img src="assets/general/cross-black.svg" />
      </div>
    </div>
    <div class="bot-holder" id="botHolder">
      <div class="img-holder">
        <img
          *ngIf="blogUser.avatarPath !== ''"
          src="{{ blogUser.avatarPath }}"
          onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
        />
        <img *ngIf="blogUser.avatarPath === ''" src="assets/blog/avatar.svg" />
      </div>
      <div class="textfield">
        <div class="textfield-holder">
          <textarea
            [(ngModel)]="text"
            rows="1"
            (ngModelChange)="
              autoGrow(isReplyActivated, post.featuredImagePath !== '');
              search()
            "
            id="textarea"
            maxlength="500"
            placeholder="نظر خود را بنویسید ..."
          ></textarea>
        </div>
        <div class="send-button" (click)="sendCommentOrReply()">ارسال</div>
      </div>
    </div>
  </div>
  <app-ios-bottomsheet
    *ngIf="showMoreOption"
    [input]="iosBottomsheetInput"
  ></app-ios-bottomsheet>
  <app-report-bottomsheet
    *ngIf="showPostCommentReport"
    [data]="bottomsheetData"
  ></app-report-bottomsheet>
</div>
<div class="search-page" id="blogWithTag{{ id }}" *ngIf="showBlogWithTag">
  <app-blog-with-tag
    [id]="tagId"
    style="width: 100%; height: 100%"
  ></app-blog-with-tag>
  <div class="blog-with-tag-back-holder" (click)="closeBlogWithTag()">
    <img src="assets/general/back-blue.svg" />
  </div>
</div>
<div class="canvas" id="canvas"></div>
<app-two-action-popup
  [inputs]="sendCommentInput"
  *ngIf="showProfilePopup"
></app-two-action-popup>
<app-two-action-popup
  [inputs]="removeCommentInput"
  *ngIf="showRemoveCommentPopup"
></app-two-action-popup>
